import r from "../managers/braze-instance.js";
export function requestImmediateDataFlush(e) {
  if (!r.rr()) return;
  var t = r.nn();
  t && t.requestImmediateDataFlush(e);
}